































































































































































































































































































































import Vue from 'vue';
import DonationCauseSelectComponent
  from '@/components/organizationgroup/donationcause/DonationCauseSelectComponent.vue';
import DonationCauseAutocompleteComponent
  from '@/components/organizationgroup/donationcause/DonationCauseAutocompleteComponent.vue';
import { AttributeType } from '@/enums/attributeType';
import { Donation } from '@/interfaces/donation/donation';
import { RequestSession } from '@/interfaces/requestSession';
import { DonationCause } from '@/interfaces/organizationgroup/donationCause';
import { AttributeValue } from '@/interfaces/donation/attributeValue';
import { DonationImage } from '@/interfaces/donation/donationImage';
import { BASE_URL, ENDPOINTS, get } from '@/api/mainApi';
import { stepV2 } from '@/enums/donationStepOrder';
import { cleanTextFromTrailingEmptyRows, countRowsInTextArea } from '@/utils';
import ImagePickerComponentCompact from '@/components/ImagePickerComponentCompact.vue';
import OptionLabel from '@/components/OptionLabel.vue';
import CertificatePreview from '@/components/global/CertificatePreviewComponent.vue';
import ValidationMixin from '@/mixins/validationMixin';
import LabelMixin from '@/mixins/labelMixin';

export default Vue.extend({
  components: {
    CertificatePreview,
    ImagePickerComponentCompact,
    DonationCauseSelectComponent,
    DonationCauseAutocompleteComponent,
    OptionLabel,
  },
  mixins: [ValidationMixin, LabelMixin],
  props: {
    showPrev: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showCertificatePreview: false,
      isChecked: false,
      dialog: false,
      valid: true,
      showCondolenceOptions: false, // specified from the external system. Doesn't always make sense
      showCause: false,
      selectedImageId: 0,
      images: [],
      defaultSelectableDonationCauses: [] as DonationCause[],
      defaultImage: null as DonationImage | null,
      textAreaValidation: {
        message: {
          maxRowSize: 130,
        },
        donorNames: {
          maxRowSize: 125,
        },
        maxTotalRowCount: 17,
        valid: true,
      },
      exampleMessages: this.$t('exampleMessages'),
      attributes: {
        subjectName: AttributeType.SUBJECT_NAME,
        greeting: AttributeType.GREETING,
        donorName: AttributeType.DONOR_NAME,
      },
      donationDetails: {
        showCondolenceOnMemorialPage: false,
        attributeValues: [
          {
            value: '',
            attributeId: AttributeType.SUBJECT_NAME,
          },
          {
            value: '',
            attributeId: AttributeType.GREETING,
          },
          {
            value: '',
            attributeId: AttributeType.DONOR_NAME,
          },
        ] as Array<AttributeValue>,
        donationCause: null,
        donationImageId: null,
      } as Donation,
    };
  },
  computed: {
    currentStep() {
      return this.$store.state.currentStep;
    },
    greetingValue: {
      get(): string {
        return this.getAttributeValueById(this.attributes.greeting) || '';
      },
      set(value: string): void {
        this.setAttributeValueById(this.attributes.greeting, value, false);
      },
    },
    canPreviewCertificate(): boolean {
      return !!this.getAttributeValueById(AttributeType.SUBJECT_NAME)
        && this.getAttributeValueById(AttributeType.SUBJECT_NAME).length > 0;
    },
    nonEmptyCategories() {
      if (this.images) {
        return this.categories.filter(
          c => this.images.filter(i => i.donationImageCategory.id === c.id).length,
        );
      }
      return this.categories;
    },
    requestSession(): RequestSession {
      return this.$store.state.requestSession;
    },
    donation(): Donation {
      return this.$store.state.donation;
    },
    isMemoryGift(): boolean {
      return true;
    },
    isContribution(): boolean {
      // todo - currently not supported
      return false;
    },
    tooManyAttributeRows(): boolean {
      return this.donationDetails && this.isMemoryGift && !this.hasValidAttributeRowCount();
    },
    hasDefaultDonationCauses(): boolean {
      return ((this.requestSession?.donationCases?.[0]?.defaultDonationCauseIds ?? 0).length);
    },
    activeRequestSessionOrganizationGroupCauses(): DonationCause[] {
      if (this.requestSession.organizationGroup) {
        return this.requestSession.organizationGroup.donationCauses.filter(
          (donationCause: DonationCause) => {
            return donationCause.active;
          },
        );
      }
      return [];
    },
    hasAnyActiveRequestSessionOrganizationGroupCauses(): boolean {
      return (
        !!this.activeRequestSessionOrganizationGroupCauses &&
        this.activeRequestSessionOrganizationGroupCauses.length > 0
      );
    },
    activeDonationCauses() {
      return this.requestSession.organizationGroup.donationCauses.filter(
        (donationCause: DonationCause) => donationCause.active,
      );
    },
  },
  watch: {
    currentStep(newVal, oldVal) {
      if (newVal === stepV2.CERTIFICATE_DETAILS && oldVal < stepV2.CERTIFICATE_DETAILS) {
        this.calculateShowCause();
        this.handleDonationCausesFromDonationCase();
      }
    },
    greetingValue: {
      handler(newValue) {
        this.calculateShowCause();
        this.showCondolenceOptions =
          !!this.requestSession.showCondolenceOnMemorialPage &&
          !!newValue.trim().length;
        // if the show condolence switch should be shown, then make it switched on by default
        if (this.showCondolenceOptions) {
          this.donationDetails.showCondolenceOnMemorialPage = true;
        }
      },
      immediate: true,
    },
  },
  created() {
    // immediately fetch image by categories if the request session has an organization group with active causes, OR there is no attached organization group
    if (this.hasAnyActiveRequestSessionOrganizationGroupCauses) {
      this.fetchImages(this.requestSession.organizationGroup.id);
    } else if (!this.requestSession.organizationGroup) {
      this.fetchImages();
    }
    if (this.currentStep === stepV2.CERTIFICATE_DETAILS) {
      this.calculateShowCause();
      this.handleDonationCausesFromDonationCase();
    }
  },
  methods: {
    getAttributeValueById(id: number): string {
      let attributeValue = this.donationDetails.attributeValues.find(a => a.attributeId === id);
      return attributeValue ? attributeValue.value : '';
    },
    setAttributeValueById(id: number, value, concat: boolean) {
      let attributeValue = this.donationDetails.attributeValues.find(a => a.attributeId === id);

      if (attributeValue) {
        if (concat) {
          attributeValue.value += value;
        } else {
          attributeValue.value = value;
        }
      }
    },
    hasValidAttributeRowCount() {
      let message = this.getAttributeValueById(AttributeType.GREETING);
      let donorNames = this.getAttributeValueById(AttributeType.DONOR_NAME);

      let totalRows = (countRowsInTextArea(message, this.textAreaValidation.message.maxRowSize) + countRowsInTextArea(donorNames, this.textAreaValidation.donorNames.maxRowSize));
      return totalRows <= this.textAreaValidation.maxTotalRowCount;
    },
    selectMessage(message) {
      this.setAttributeValueById(AttributeType.GREETING, message, true);
      this.dialog = false;
    },
    fetchImages(organizationGroupId) {
      get(ENDPOINTS.IMAGE_CATEGORIES, organizationGroupId)
        .then(c => {
          this.categories = c;
          this.categories.sort((a, b) => {
            const aComp = a.organizationGroupId == null ? 0 : 1;
            const bComp = b.organizationGroupId == null ? 0 : 1;
            return bComp - aComp;
          });
        });
      get(ENDPOINTS.IMAGES, organizationGroupId)
        .then(
          r =>
            (this.images = r.map((image: DonationImage) => ({
              ...image,
              url: BASE_URL + image.url + '?compression=true',
            }))),
        )
        .finally(() => {
          // retrieve the default image
          this.defaultImage = this.images.find(i => i.defaultImage);

          if (this.defaultImage) {
            this.selectedImageId = this.defaultImage.id;
          } else if (this.images.length > 0) {
            // if the default image wasn't found, take the first best image (this should never happen)
            this.selectedImageId = this.images[0].id;
          } else {
            // this is disaster mode, and should absolutely not happen. We just pick the very first id, so that an image will be preselected
            this.selectedImageId = 1;
          }
          this.images.sort();
        });
    },
    calculateShowCause() {
      if (
        this.activeRequestSessionOrganizationGroupCauses &&
        this.activeRequestSessionOrganizationGroupCauses.length === 1
      ) {
        this.showCause = false;
        this.donationDetails.donationCause = this.activeRequestSessionOrganizationGroupCauses[0];
      } else {
        this.showCause = true;
      }
    },
    cleanAttributeTexts() {
      let greetingAttribute = cleanTextFromTrailingEmptyRows(this.getAttributeValueById(this.attributes.greeting));
      this.setAttributeValueById(this.attributes.greeting, greetingAttribute, false);

      let namesAttribute = cleanTextFromTrailingEmptyRows(this.getAttributeValueById(this.attributes.donorName));
      this.setAttributeValueById(this.attributes.donorName, namesAttribute, false);
    },
    async handleDonationCausesFromDonationCase() {
      this.loading = true;
      // handle defaultDonationCause from the selected DonationCase if one is selected
      if (this.hasDefaultDonationCauses) {
        const causeIds: number[] = this.requestSession.donationCases[0].defaultDonationCauseIds;
        if (causeIds.length === 1) {
          this.donationDetails.donationCause = await this.getDonationCauseWithId(
            this.requestSession.donationCases[0].defaultDonationCauseIds[0],
          );
          this.fetchImages(this.donationDetails.donationCause.organizationGroup.id);
        } else if (causeIds.length > 1) {
          this.defaultSelectableDonationCauses = await this.getDonationCausesWithIds(causeIds);
        }
      }
      this.loading = false;
    },
    async getDonationCauseWithId(id: number) {
      return await get(ENDPOINTS.DONATION_CAUSES + '/' + id);
    },
    async getDonationCausesWithIds(ids: number[]): Promise<DonationCause[]> {
      return await get(ENDPOINTS.DONATION_CAUSES + '?ids=' + ids.join(','));
    },
    next() {
      if (!this.$refs.form.validate()) {
        // TODO: Break out and reuse for other form steps
        for (var i = 0; i < this.$refs.form.$children.length; i++) {
          const child = this.$refs.form.$children[i];
          if (child.valid === false) {
            this.$vuetify.goTo(child, { offset: 100 });
          }
        }
        return;
      }

      let donation: Donation = this.donation;
      if (this.isMemoryGift) {
        this.cleanAttributeTexts();
        donation.attributeValues = this.donationDetails.attributeValues;
        donation.donationImageId = this.donationDetails.donationImageId;
      }

      donation.donationCause = this.donationDetails.donationCause;
      donation.showCondolenceOnMemorialPage = this.donationDetails.showCondolenceOnMemorialPage;
      this.$store.commit('updateDonation', donation);
      this.$emit('nextStep');
    },
  },
});
